import { CountryIsoCode } from '../countryIsoCodes'

export type DefaultStateStrings = Partial<
  Record<CountryIsoCode, Record<string, string>>
>

export const defaultStateStrings: DefaultStateStrings = {
  US: {
    'usState.name.alabama': 'Alabama',
    'usState.name.alaska': 'Alaska',
    'usState.name.americanSamoa': 'American Samoa',
    'usState.name.arizona': 'Arizona',
    'usState.name.arkansas': 'Arkansas',
    'usState.name.bakerIsland': 'Baker Island',
    'usState.name.california': 'California',
    'usState.name.colorado': 'Colorado',
    'usState.name.connecticut': 'Connecticut',
    'usState.name.delaware': 'Delaware',
    'usState.name.districtOfColumbia': 'District of Columbia',
    'usState.name.florida': 'Florida',
    'usState.name.georgia': 'Georgia',
    'usState.name.guam': 'Guam',
    'usState.name.hawaii': 'Hawaii',
    'usState.name.howlandIsland': 'Howland Island',
    'usState.name.idaho': 'Idaho',
    'usState.name.illinois': 'Illinois',
    'usState.name.indiana': 'Indiana',
    'usState.name.iowa': 'Iowa',
    'usState.name.jarvisIsland': 'Jarvis Island',
    'usState.name.johnstonAtoll': 'Johnston Atoll',
    'usState.name.kansas': 'Kansas',
    'usState.name.kentucky': 'Kentucky',
    'usState.name.kingmanReef': 'Kingman Reef',
    'usState.name.louisiana': 'Louisiana',
    'usState.name.maine': 'Maine',
    'usState.name.maryland': 'Maryland',
    'usState.name.massachusetts': 'Massachusetts',
    'usState.name.michigan': 'Michigan',
    'usState.name.midwayAtoll': 'Midway Atoll',
    'usState.name.minnesota': 'Minnesota',
    'usState.name.mississippi': 'Mississippi',
    'usState.name.missouri': 'Missouri',
    'usState.name.montana': 'Montana',
    'usState.name.navassaIsland': 'Navassa Island',
    'usState.name.nebraska': 'Nebraska',
    'usState.name.nevada': 'Nevada',
    'usState.name.newHampshire': 'New Hampshire',
    'usState.name.newJersey': 'New Jersey',
    'usState.name.newMexico': 'New Mexico',
    'usState.name.newYork': 'New York',
    'usState.name.northCarolina': 'North Carolina',
    'usState.name.northDakota': 'North Dakota',
    'usState.name.northernMarianaIslands': 'Northern Mariana Islands',
    'usState.name.ohio': 'Ohio',
    'usState.name.oklahoma': 'Oklahoma',
    'usState.name.oregon': 'Oregon',
    'usState.name.palmyraAtoll': 'Palmyra Atoll',
    'usState.name.pennsylvania': 'Pennsylvania',
    'usState.name.puertoRico': 'Puerto Rico',
    'usState.name.rhodeIsland': 'Rhode Island',
    'usState.name.southCarolina': 'South Carolina',
    'usState.name.southDakota': 'South Dakota',
    'usState.name.tennessee': 'Tennessee',
    'usState.name.texas': 'Texas',
    'usState.name.unitedStatesMinorOutlyingIslands':
      'United States Minor Outlying Islands',
    'usState.name.unitedStatesVirginIslands': 'United States Virgin Islands',
    'usState.name.utah': 'Utah',
    'usState.name.vermont': 'Vermont',
    'usState.name.virginia': 'Virginia',
    'usState.name.wakeIsland': 'Wake Island',
    'usState.name.washington': 'Washington',
    'usState.name.westVirginia': 'West Virginia',
    'usState.name.wisconsin': 'Wisconsin',
    'usState.name.wyoming': 'Wyoming'
  },
  CA: {
    'caState.name.alberta': 'Alberta',
    'caState.name.britishColumbia': 'British Columbia',
    'caState.name.manitoba': 'Manitoba',
    'caState.name.newBrunswick': 'New Brunswick',
    'caState.name.newfoundlandAndLabrador': 'Newfoundland and Labrador',
    'caState.name.novaScotia': 'Nova Scotia',
    'caState.name.northwestTerritories': 'Northwest Territories',
    'caState.name.nunavut': 'Nunavut',
    'caState.name.ontario': 'Ontario',
    'caState.name.princeEdwardIsland': 'Prince Edward Island',
    'caState.name.quebec': 'Quebec',
    'caState.name.saskatchewan': 'Saskatchewan',
    'caState.name.yukon': 'Yukon'
  }
}
